import { createTheme } from '@mantine/core';

export const theme = createTheme({
    primaryColor: 'indigo',
    defaultRadius: 'sm',
    components: {
        AppShell: {
            styles: () => ({
                navbar: {
                    backgroundColor: 'var(--mantine-color-body)',
                },
                main: {
                    backgroundColor: 'light-dark(var(--mantine-color-gray-0), var(--mantine-color-dark-8))',
                },
                header: {
                    boxShadow: '0 1px 2px light-dark(rgba(0,0,0,0.06), rgba(0,0,0,0.2))',
                },
            }),
        },
        Card: {
            defaultProps: {
                shadow: 'sm',
            },
        },
        Title: {
            styles: () => ({
                root: { fontWeight: 600 },
            }),
        },
    },
});
